import React, { Component } from 'react';
/* eslint-disable */
const techPartner = require('../../assets/images/techpartners.PNG')
export default class TechnologyPartners extends Component {
    constructor(props){
        super(props)
        this.state={
            mobile:false,
            msgCount:0,
            maxMsg:250,
            msg:''
        }
    }
    componentDidMount(){
        window.scrollTo(0,0)
        if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            this.setState({mobile:true})
        }
    }
    messageHandler = (e) => {
        const value = e.target.value
        if(value&&value.length){
            this.setState({msg:value,msgCount:value.length})
        } else {
            this.setState({msgCount:0})
        }
    }

    submitForm = (e) => e.preventDefault()

    render() {
        const {mobile,maxMsg,msgCount} = this.state
        return (
            <React.Fragment>
                <div className="container contact-margin">
                    <div className="tech-bg">
                        <div className={!mobile ? "row text-left": "row"}>
                            <div className="mt-3 mb-3">
                                <img className="img-fluid" src={techPartner} alt="" srcset=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
